export default "__VITE_ASSET__DpeDCL8C__"